import { GridViewMetadata } from 'apps/webcomponents/src/grid/gridView/types';
import { SelectOption } from 'apps/webcomponents/src/ui/gzSelect/types';
import { Column, ColumnKeys } from './grid';
import { GridViewWebComponent } from '../../../grid/gridView';
import { Filter } from '../../../grid/gridFilters/types';

export interface ComputersAndVirtualMachinesWebComponentSchema {
  viewMetaData: GridViewMetadata<Column, ColumnKeys>;
  actions: Array<SelectOption>;
  canHaveCompanyDownload: boolean;
}

export interface ComputersAndVirtualMachinesViewData {
  externalFilters: Filter<ColumnKeys>[];
}

export interface RestoreFormData {
  restoreType: number;
  restorePath: string;
  isValid: boolean;
}

export enum RestoreType {
  ORIGINAL_LOCATION,
  FOLDER,
}

export enum SelectableAction {
  RESTORE_ORIGINAL = '3',
  RESTORE = '4',
}

export interface Dependencies {
  api: {
    type: string;
  };
  translateFn: Function;
  getTimezone: Function;
  getUserLanguage: Function;
  navigateToTasks: EventListenerOrEventListenerObject;
  navigateToSandbox: Function;
  navigateToConfigurationProfiles: Function;
  getCurrentUserCompany: Function;
  permissions: Permissions;
  getActiveCompany: Function;
}

export interface Permissions {
  canHaveChildCompanies: boolean;
  canHaveCompanyDownload: boolean;
}

export const MAX_FILE_SIZE = 26214400; // 25 * 1024 * 1024 = 25MB

export enum RETRIEVE_ERROR_CODES {
  ENDPOINT_UNMANAGED_ERROR_CODE = 3341,
  USER_WITH_2FA_DISABLE_ERROR_CODE = 3344,
  MA_DISABLED_ERROR_CODE = 3345,
  OS_NOT_SUPPORTED = 3355,
  QUARANTINE_NUMBER_OF_RETRIEVED_FILES_LIMIT_REACHED = 3360,
  COMPANY_IS_NOT_AVAILABLE_FOR_QUARANTINE_RETRIEVE = 3361
}

export enum SUBMIT_ERROR_CODES {
  INCORRECT_ARCHIVE_PASSWORD = 3362,
}

export const PASSWORD_MIN_LENGTH = 6;
export const PASSWORD_MAX_LENGTH = 128;

export interface RetrievedQuarantineFileData {
  quarantineId: string,
  fileId: string,
  archiveName: string,
  companyId?: string,
  fileSize?: number,
}

export interface DomSchema {
  $grid: GridViewWebComponent<Column, ColumnKeys>
}
